import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import VatDeadlinesTableActions from '@/components/vat-deadlines/VatDeadlinesTableActions.vue';
import { useDateFormat } from '@/composables/useDateFormat';
import type { VatDeadline } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

const { formatDMYFromIso } = useDateFormat();

export const columns: ColumnDef<VatDeadline>[] = [
    {
        accessorKey: 'vat_deadline_id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'period_lang',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'system.vat_deadlines.month',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        accessorKey: 'settlement_period',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'system.vat_deadlines.settle_period',
            }),
        sortingFn: (rowA, rowB) => {
            const a = rowA.original?.settlement_period_from ?? '';
            const b = rowB.original?.settlement_period_from ?? '';
            if (!a && !b) return 0;
            if (!a) return -1;
            if (!b) return 1;
            return a.localeCompare(b);
        },
        filterFn: 'periodRange',
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        accessorKey: 'deadline',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'system.vat_deadlines.deadline',
            }),
        cell: ({ row }) => {
            return formatDMYFromIso(row.original.deadline);
        },
        filterFn: 'dateRange',
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(VatDeadlinesTableActions, {
                vatDeadline: row.original,
            });
        },
    },
];
